export default __webpack_public_path__ + "d3f9c8f052b5e9f4e7cbf84276b7492f.svg";